<template>
    <a :href="href" @click.prevent="openInModal">
        <slot />
    </a>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        href: {
            type: String,
            required: true,
        },
        directUrl: {
            type: String,
            default: null,
        },
    },
    methods: {
        openInModal() {
            // Fallback to normal navigation if event bus is unavailable.
            // @ts-ignore
            if (!this.$events || !this.$events.$emit) {
                window.location.assign(this.href);
                return;
            }

            // @ts-ignore
            this.$events.$emit("openModal", {
                interactiveImage: this.directUrl || this.href,
            });
        },
    },
});
</script>
